/**
 * Node modules
 */
import styled from 'styled-components';

/**
 * Private modules
 */
import { scale } from '../.private';

/**
 * Styled components
 */
export default styled.div`
  align-items: center;
  display: flex;
  font-size: ${scale.major(2)}px;
  height: ${scale.major(8)}px;
  justify-content: flex-end;
  margin-left: auto;
  transition: all 0.3s;
`;
